// -
import React from "react";
import {DetailLeftIcon, Icon} from "./../index";
import classNames from "classnames";
import * as subjektFormatter from "./../utils/subjektFormatter";
import * as StavZtotozneniZr from "./../api/gen/proxioapi/StavZtotozneniZr";
import "./SubjektRow.scss";
import * as SubjektTools from "./SubjektTools";
import SubjektRowDetail from "./SubjektRowDetail";

/**
 * Kompoennta pro zobrazení subjektu, který je zobrazen v řádku např. jako seznam.
 * Výpis subjektu je 2/3 řádkový.
 * 1. řádek - Plný název, např. i včetně IČ, BEZ adresy, např. "ing. jan metelka csc, RČ: 8555191873" nebo "Obec Testovací, IČO: 00234897" apod.
 * 2. řádek - Adresa
 * 3, řádek - zástupce, pokud je předaný
 */
export default class RubjektRow extends React.Component {
    static propTypes = {
        subjekt: React.PropTypes.object.isRequired,  // subjekt
        subjektRenderComponent: React.PropTypes.oneOfType([   // renderovací komponenta pro subjekt
             React.PropTypes.func,
             React.PropTypes.string
        ]),
        zastupce: React.PropTypes.object,    // zástupce, pokud jej chceme zobrazovat, bere se tento zástupce, NEBERE se zástupce přímo z objektu subjekt
        renderZastupce: React.PropTypes.func,  // pokud je uvedeno, renderuje zástupce, předpis (zastupce, label) => {}, kde label je text, který je doporučený pro zobrazení zástupce a zastupce je vlastní objekt zástupce
        showZRIcon: React.PropTypes.bool, // pokud je true, zobrazuje se u subjektu ikona s informací o stavu vůči ZR, standardně false
        zastupceLabel: React.PropTypes.string,  // text který je uveden před zástupcem, implicitně "zástupce"
        bezAdresy: React.PropTypes.bool, // u subjektu se nezobrazí řádek s adresou
    };

    static defaultProps = {
        renderZastupce: (zastupce, label) => {
            const {title, dead} = SubjektTools.getDeadInfo(zastupce);
            return <span className={dead ? "zastupce dead" : "zastupce"} title={title}>
                <span className="subjekt-name">{label}</span>
            </span>
        },
        subjektRenderComponent: SubjektRowDetail,
        showZRIcon: false,
        zastupceLabel: "zástupce",
        bezAdresy: false
    };

    /**
     * Renderování ikony ověření subjektu vůči ZR.
     * @param dead true, pokud je zemřelý nebo zaniklý
     * @return {XML}
     */
    renderIcon = (dead) => {
        const {subjekt} = this.props;

        // TODO [stanekpa] - přepsat shared stavy a upravit i toto
        let icon;
        let cls;
        let title;
        if (dead) {
            icon = "user-times";
        } else {
            if (subjekt.vazbaZr && subjekt.stavZr) {
                switch (subjekt.stavZr.stavZtotozneni) {
                    case StavZtotozneniZr.ZTOTOZNEN:
                        icon = "check";
                        title = "Ztotožněn vůči základním registrům";

                        if (subjekt.stavZr.zpochybneneUdaje) {
                            cls = "text-warning";
                            title += " (zpochybněné údaje: " + subjekt.stavZr.zpochybneneUdaje + ")";
                        }
                        break;
                    case StavZtotozneniZr.NEZTOTOZNEN:
                        icon = "exclamation-triangle";
                        title = "Neztotožněn vůči základním registrům";
                        if (subjekt.stavZr.duvodNeztotozneni) {
                            title += " (" + subjekt.stavZr.duvodNeztotozneni + ")";
                        }
                        break;
                    case StavZtotozneniZr.POZASTAVEN:
                        icon = "pause";
                        title = "Pozastaveno vůči základním registrům";
                        break;
                    case StavZtotozneniZr.CHYBA:
                        icon = "remove";
                        title = "Chyba při ztotožnění vůči základním registrům";
                        break;
                }
            } else {
                icon = "minus";
                title = "Subjekt je bez vazby na ZR"
            }
        }

        return <Icon className={cls} icon={icon} title={title}/>;
    };

    render() {
        const {children, zastupceLabel, showZRIcon, className, subjekt, zastupce, renderZastupce, bezAdresy,
            subjektRenderComponent} = this.props;

        let zastupceComp;
        if (zastupce) {
            zastupceComp = <div>
                <small>
                    ({zastupceLabel}: {renderZastupce(zastupce, subjektFormatter.getUplnyNazev(zastupce))})
                </small>
            </div>
        }

        // Úmrtí nebo ukončení subjektu
        const {title, dead} = SubjektTools.getDeadInfo(subjekt);

        const cls = classNames(className, "subjekt-row-container", {
            dead
        });

        const sbjRender = React.createElement(subjektRenderComponent, {subjekt, bezAdresy});

        if (showZRIcon) {
            return <DetailLeftIcon title={title} className={cls} icon={this.renderIcon(dead)}>
                {sbjRender}
                {zastupceComp}
            </DetailLeftIcon>
        } else {
            return <div title={title} className={cls}>
                <div className="subjekt-row-subjekt">
                    {sbjRender}
                    {zastupceComp}
                </div>
                {children && <div className="subjekt-row-additional-info">
                    {children}
                </div>}
            </div>
        }
    }
}
